import React from 'react';
import styles from "./empty-card.module.scss";
import Icon from '../svg-icon/icon';


const EmptyCard = ({text, onClick}) => {

    return (
        <div className={`d-flex flex-column justify-content-center align-items-center ${styles.emptyCard}`} onClick={onClick}>
            <div className={styles.text}>{text}</div>
            <div className={`${styles.icon} ${styles.icon32}`}>
                    <Icon name="plus" />
            </div>
        </div>
    );
  };
  
  export default EmptyCard;